import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import * as React from 'react';
import { Fragment, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { RefactoredDevice } from '../@types/model/device';
import { useTranslation } from 'react-i18next';
import { ProductType } from '../@types/model/productType';
import { useRecoilValue } from 'recoil';
import { productTypeState } from 'recoil/productTypeState';

export interface DeviceToEditFormProps {
  submitHander: (tipo_de_producto: string | null, numero_de_crianza: string | null) => void;
  loading: boolean;
  refactoredDevice: RefactoredDevice;
}

const DeviceToEditForm = (props: DeviceToEditFormProps) => {
  const { t } = useTranslation();
  const [tipoDeProducto, setTipoDeProducto] = useState<string | null>('');
  const [numeroDeCrianza, setNumeroDeCrianza] = useState<string | null>('');
  const productTypes: ProductType[] = useRecoilValue(productTypeState);
  // const [write, setWrite] = useState<string>(false);
  React.useEffect(() => {
    setTipoDeProducto(props.refactoredDevice.tipo_de_producto);
    setNumeroDeCrianza(props.refactoredDevice.numero_de_crianza);
  }, []);
  return (
    <Fragment>
      <FormControl fullWidth style={{ marginTop: 10 }}>
        <InputLabel id={'device-type-select-label'}>{t('select_feed_type')}</InputLabel>
        <Select
          labelId={'device-type-select-label'}
          id={'device-type-select'}
          value={tipoDeProducto}
          label={t('feed_type')}
          onChange={(event) => {
            setTipoDeProducto(event.target.value);
          }}
        >
          {productTypes.map((pt) => {
            return (
              <MenuItem key={pt.guid} value={pt.guid}>
                {pt.name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <TextField
        fullWidth
        type="text"
        value={numeroDeCrianza}
        label={t('breeding_number')}
        onChange={(event) => {
          setNumeroDeCrianza(event.target.value);
        }}
        sx={{ mt: 1, mb: 2 }}
      />
      <LoadingButton
        sx={{ marginTop: '15px' }}
        variant={'contained'}
        loading={props.loading}
        onClick={() => {
          props.submitHander(tipoDeProducto, numeroDeCrianza);
        }}
      >
        {t('save')}
      </LoadingButton>
    </Fragment>
  );
};
export default DeviceToEditForm;
